module.exports = __webpack_public_path__ + "public/files/img/qr-code.278df45f.png";